import { useTheme } from '@/design-system';
import { useState, useEffect } from 'react';
import { useFocusedWindow } from '../Window/WindowManager';
import styles from './StatusBar.module.css';
import { SunIcon, MoonIcon, HeartIcon, WifiIcon } from '../icons';

export function StatusBar() {
  const { theme, setTheme } = useTheme();
  const [currentTime, setCurrentTime] = useState<string>('');
  const focusedWindow = useFocusedWindow();

  useEffect(() => {
    const updateTime = () => {
      setCurrentTime(
        new Date().toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
      );
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.statusBar}>
      <div className={styles.statusLeft}>
        <span className={styles.menuIcon} aria-label="Menu">
          {focusedWindow ? focusedWindow.icon : <HeartIcon />}
        </span>
        {focusedWindow && (
          <span className={styles.activeApp}>
            {focusedWindow.title}
          </span>
        )}
      </div>
      <div className={styles.statusRight}>
        <button
          className={styles.themeToggle}
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>
        <span className={styles.menuIcon} aria-label="Wifi">
          <WifiIcon />
        </span>
        <span className={styles.statusTime} suppressHydrationWarning>
          {currentTime}
        </span>
      </div>
    </div>
  );
}
